/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Options_Watermark_Save_Failed_ToastInputs */

const en_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update watermark settings: ${i?.error}`)
};

const fr_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la mise à jour des paramètres du filigrane : ${i?.error}`)
};

const de_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wasserzeichen-Einstellungen konnten nicht aktualisiert werden: ${i?.error}`)
};

const it_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aggiornare le impostazioni della filigrana: ${i?.error}`)
};

const ru_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обновить настройки водяного знака: ${i?.error}`)
};

const es_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron actualizar los ajustes de marca de agua: ${i?.error}`)
};

const zh_cn2_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新水印设置失败：${i?.error}`)
};

const ja_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ウォーターマークの設定を更新できませんでした: ${i?.error}`)
};

const hi_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वॉटरमार्क सेटिंग्स अपडेट करने में विफल: ${i?.error}`)
};

const pt_pt2_options_watermark_save_failed_toast = /** @type {(inputs: Options_Watermark_Save_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar as definições de marca de água: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to update watermark settings: {error}" |
*
* @param {Options_Watermark_Save_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_save_failed_toast = /** @type {((inputs: Options_Watermark_Save_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Save_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_watermark_save_failed_toast(inputs)
	if (locale === "de") return de_options_watermark_save_failed_toast(inputs)
	if (locale === "it") return it_options_watermark_save_failed_toast(inputs)
	if (locale === "ru") return ru_options_watermark_save_failed_toast(inputs)
	if (locale === "es") return es_options_watermark_save_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_options_watermark_save_failed_toast(inputs)
	if (locale === "ja") return ja_options_watermark_save_failed_toast(inputs)
	if (locale === "hi") return hi_options_watermark_save_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_options_watermark_save_failed_toast(inputs)
	return en_options_watermark_save_failed_toast(inputs)
});